import { IUser } from "../../api/services/auth/models";
import { IMyInfoData } from "../../api/services/profile/models";
import { getAccessTokenSync, getUserInfoFromToken } from "../../auth/oidc";

export class AuthConfig {
  // ---- User token — now managed by Keycloak internally ----
  // getToken() returns the Keycloak sync token for legacy callers that decode the JWT directly.
  static readonly getToken: () => string | null = () => getAccessTokenSync();
  static readonly setToken = (_token: string | null) => { /* no-op: Keycloak manages tokens */ };

  static readonly getRefreshToken: () => string | null = () => null;
  static readonly setRefreshToken = (_token: string | null) => { /* no-op */ };

  static readonly getExpiresAt: () => string | null = () => null;
  static readonly setExpiresAt = (_time: string | null) => { /* no-op */ };

  // ---- User info — read from Keycloak token claims ----
  // All existing call sites (getUserInfo().id, .userIdentification, .authorities, etc.) continue to work.
  static readonly getUserInfo: () => IUser = () =>
    getUserInfoFromToken() as IUser;

  static readonly setUserInfo = (_info?: IUser | null) => {
    // no-op: user info comes from the Keycloak token, not localStorage
    // Called during logout to clear any stale state — nothing to clear here.
  };

  // ---- My profile info — still stored in localStorage (fetched from /profile API) ----
  private static readonly myInfoKey = "myInfo";
  static readonly setMyInfo = (info?: IMyInfoData | null) => {
    if (info) {
      window.localStorage.setItem(AuthConfig.myInfoKey, JSON.stringify(info));
    } else {
      window.localStorage.removeItem(AuthConfig.myInfoKey);
    }
  };
  static readonly getMyInfo: () => IMyInfoData = () => {
    const myInfoString = window.localStorage.getItem(AuthConfig.myInfoKey);
    if (myInfoString) {
      return JSON.parse(myInfoString);
    }
    return null;
  };

  // ---- App-token (client_credentials) — unchanged, still in localStorage ----
  private static readonly appTokenKey = "appTokenKey";
  static readonly setAppToken = (token: string | null) => {
    if (token === null) {
      window.localStorage.removeItem(AuthConfig.appTokenKey);
    } else {
      window.localStorage.setItem(AuthConfig.appTokenKey, token);
    }
  };
  static readonly getAppToken: () => string | null = () => {
    return window.localStorage.getItem(AuthConfig.appTokenKey);
  };
}
